import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Pessoas',
    path: '/administracao/pessoas',
    name: 'pessoas',
    component: () => import('@/views/administracao/pessoas/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PESSOASNOVO_MENU_2200100101],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Pessoas',
    path: '/administracao/pessoas/cadastro/:id?',
    parent: 'pessoas',
    name: 'pessoa_create',
    component: () => import('@/views/administracao/pessoas/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.PESSOASNOVO_MENU_2200100101],
    },
  },
]

